export enum Market {
  Opensea = 'opensea',
  Sansa = 'sansa',
  ArtBlocks = 'artblocks',
  LooksRare = 'looksrare',
  X2Y2 = 'x2y2',
  Reservoir = 'reservoir',
  Coinbase = 'coinbase',
  Rarible = 'rarible',
  Foundation = 'foundation'
}

export enum Platform {
  ArtBlocks = 'ART_BLOCKS',
  ArtBlocksCurated = 'ART_BLOCKS_CURATED',
  ArtBlocksPresents = 'ART_BLOCKS_PRESENTS',
  ArtBlocksCollaborations = 'ART_BLOCKS_COLLABORATIONS',
  ArtBlocksPlayground = 'ART_BLOCKS_PLAYGROUND',
  ArtBlocksFactory = 'ART_BLOCKS_FACTORY',
  ArtBlocksExplorations = 'ART_BLOCKS_EXPLORATIONS',
  ArtBlocksStudio = 'ART_BLOCKS_STUDIO',
  GrailersDao = 'GRAILERS_DAO',
  BrightMoments = 'BRIGHT_MOMENTS',
  Plottables = 'PLOTTABLES',
  Proof = 'PROOF',
  VCA = 'VERTICAL_CRYPTO_ART',
  Hodlers = 'HODLERS',
  Trameparis = 'TRAMEPARIS',
  TrameCPG = 'TRAMECPG',
  Artwrld = 'ARTWRLD',
  ATP = 'ATP',
  AOI = 'AOI',
  Endaoment = 'ENDAOMENT',
  CoinDesk = 'COINDESK',
  NineDccxyz = '9DCCXYZ',
  RedLion = 'RED_LION',
  Axiom = 'AXIOM',
  Elsewhere = 'ELSEWHERE',
  FlamingoDao = 'FLAMINGO_DAO',
  FabDao = 'FAB_DAO',
  GazelliArtHouse = 'GAZELLI_ART_HOUSE',
  LegendsOfMetaterra = 'LEGENDS_OF_METATERRA',
  LightHouseCards = 'LIGHT_HOUSE_CARDS',
  Shiseido = 'SHISEIDO',
  Sothebys = 'SOTHEBYS',
  SquiggleDao = 'SQUIGGLE_DAO',
  TBOAClub = 'TBOA_CLUB',
  Tender = 'TENDER',
  UnitLondon = 'UNIT_LONDON',
  VertuFineArt = 'VERTU_FINE_ART',
  DisruptiveGallery = 'DISRUPTIVE_GALLERY',
  GlitchGallery = 'GLITCH_GALLERY',
  NobleGallery = 'NOBLE_GALLERY',
  HouseOfQoa = 'HOUSE_OF_QOA',
  DavisEditions = 'DAVIS_EDITIONS',
  Stitchables = 'STITCHABLES'
}

export type Activity = {
  _id?: string
  kind: ActivityKind

  contractAddress: string
  tokenId: string

  fromAddress?: string
  toAddress?: string
  transactionHash?: string
  priceInEth?: number
  priceInUsd?: number
  price?: Price

  assetId: string
  asset?: {
    id: string
    name: string
    imageUrl?: string
    imageThumbnailUrl?: string
  }
  collectionId: string
  assetCollection?: {
    id: string
    // slug: string;
    name: string
    platform?: Platform
    tags?: string[]
  }
  artistId: string // just supporting single artist for now to keep aggregations simple
  artist?: {
    id: string
    slug: string
    name: string
  }

  // listings / bid details
  order?: {
    reservoirOrderId?: string | null
    side?: 'ask' | 'bid'
    sourceOrderbook?: Market
    sourceFilledBy?: Market
  }

  // wallet detailed info
  fromAddressWalletInfo?: WalletInfo
  toAddressWalletInfo?: WalletInfo

  // listing price lower the collection floor
  collectionFloorPriceReset?: {
    oldPriceInEth?: number
    newPriceInEth?: number
  }

  // the number of times this user has listed the asset
  assetRelistingCount?: number

  // time the event happened
  occurredAt?: Date
  // timestamp updated the object in DB
  updatedAt?: Date
  // timestamp added to the DB
  createdAt?: Date
}

export type ActivityKind = 'ask' | 'sale'
export type ActivityOrderSide = 'ask' | 'bid'

export type Price = {
  currency?: {
    contract?: string
    name?: string
    symbol?: string
    decimals?: number
  }
  amount?: {
    raw?: string
    decimal?: number
    usd?: number
    native?: number
  }
  netAmount?: {
    raw?: string
    decimal?: number
    usd?: number
    native?: number
  }
}

export type WalletInfo = {
  addresses: string[]
  name?: string
  usernameTwitter?: string
  tags?: WalletTag[]
  avatarUrl?: string
}

export type WalletTag = 'INFLUENCER' | 'ARTIST' | 'FUND'

// Types for listing response

export type Asset = {
  id: string
  name: string
  imageUrl: string
  imageThumbnailUrl: string
}

export type AssetCollection = {
  id: string
  name: string
  platform: string
  tags: string[]
}

export type Artist = {
  id: string
  slug: string
  name: string
}

export type Order = {
  reservoirOrderId: string
  sourceOrderbook: string
}

export type CollectionFloorPriceReset = {
  oldPriceInEth: number
  newPriceInEth: number
}

export type Listing = {
  _id: string
  contractAddress: string
  kind: 'ask'
  tokenId: string
  artistId: string
  assetId: string
  collectionId: string
  fromAddress: string
  occurredAt: string
  createdAt: string
  priceInEth: number
  priceInUsd: number
  price: Price
  asset: Asset
  assetCollection: AssetCollection
  artist: Artist
  order: Order
  assetRelistingCount: number
  collectionFloorPriceReset?: CollectionFloorPriceReset
}
